export const messages = {
  en: {
    couponPropertyUser: {
      scanPlaceholder: 'Please scan with barcode scanner',
      verify: 'Verify',
      verifyResult: 'Verification Result',
      verifyTime: 'Verification Time',
      couponName: 'Coupon Name',
      faceValue: 'Face Value',
      userName: 'User Name',
      phone: 'Phone',
      purpose: 'Purpose',
      searchCondition: 'Search Conditions',
      couponNamePlaceholder: 'Please enter coupon name',
      userNamePlaceholder: 'Please enter user name',
      phonePlaceholder: 'Please enter phone number',
      usageRecord: 'Coupon Usage Records',
      serialNumber: 'No.',
      usageTime: 'Usage Time',
      scanTip: 'Please scan first',
      verifySuccess: 'Verification successful',
      fetchError: 'Failed to fetch data'
    }
  },
  zh: {
    couponPropertyUser: {
      scanPlaceholder: '请扫码枪扫码核销',
      verify: '核销',
      verifyResult: '核销结果',
      verifyTime: '核销时间',
      couponName: '优惠券名称',
      faceValue: '面值',
      userName: '用户名称',
      phone: '手机号',
      purpose: '用途',
      searchCondition: '查询条件',
      couponNamePlaceholder: '请填写优惠券名称',
      userNamePlaceholder: '请填写用户名称',
      phonePlaceholder: '请填写手机号',
      usageRecord: '优惠券使用记录',
      serialNumber: '编号',
      usageTime: '使用时间',
      scanTip: '请先扫码',
      verifySuccess: '核销成功',
      fetchError: '获取数据失败'
    }
  }
}